import { Users } from '@or-sdk/users';

import { useAuthStore } from '@/stores/auth/auth';

import config from '../config';

export default new Users({
  token: () => useAuthStore().reactiveToken as string,
  usersUrl: config.USERS_API_URL,
  sdkUrl: `${config.SDK_API_URL}`,
});
